export const URL_TRANSACTION_PROD =
	'https://gnosis.blockscout.com/tx';

export const URL_TRANSACTION_STAGING =
	'https://gnosis-chiado.blockscout.com/tx';
